(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hotspots"] && !Shopify.designMode) return;
  try {
    class HotspotsManager {
    constructor(container) {
      this.container = container;
      this.hotspotTriggers = container.querySelectorAll('[data-hotspot-trigger]');
      this.productCards = container.querySelectorAll('[data-product-card]');
      this.currentActiveIndex = null;

      this.init();
    }

    init() {
      // Hide all product cards initially
      this.hideAllProducts();

      // Add click listeners to hotspot triggers
      this.hotspotTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const productIndex = parseInt(trigger.dataset.hotspotTrigger);
          this.showProduct(productIndex);
        });
      });

      // Show first available product if there are hotspots
      if (this.hotspotTriggers.length > 0) {
        const firstTrigger = this.hotspotTriggers[0];
        const firstIndex = parseInt(firstTrigger.dataset.hotspotTrigger);
        this.showProduct(firstIndex);
      }
    }

    hideAllProducts() {
      this.productCards.forEach((card) => {
        card.classList.add('hidden');
        card.classList.remove('block');
        card.style.opacity = '0';
      });
    }

    showProduct(index) {
      if (index === this.currentActiveIndex) return;

      // Hide current product card if there is one
      if (this.currentActiveIndex !== null) {
        const currentCard = this.container.querySelector(`[data-product-card="${this.currentActiveIndex}"]`);
        if (currentCard) {
          currentCard.style.opacity = '0';
          setTimeout(() => {
            currentCard.classList.add('hidden');
            currentCard.classList.remove('block');
          }, 150);
        }
      }

      // Show new product card
      const newCard = this.container.querySelector(`[data-product-card="${index}"]`);
      if (newCard) {
        const showCard = () => {
          newCard.classList.remove('hidden');
          newCard.classList.add('block');
          newCard.style.opacity = '0';

          // Force reflow
          newCard.offsetHeight;

          newCard.style.transition = 'opacity 0.3s ease-in-out';
          newCard.style.opacity = '1';
        };

        // If this is the first card being shown, show immediately
        if (this.currentActiveIndex === null) {
          showCard();
        } else {
          // Otherwise wait for fade out
          setTimeout(showCard, 150);
        }
      }

      this.currentActiveIndex = index;
      this.updateActiveStates(index);
    }

    updateActiveStates(activeIndex) {
      // Update hotspot dot states
      this.hotspotTriggers.forEach((trigger) => {
        const triggerIndex = parseInt(trigger.dataset.hotspotTrigger);
        if (triggerIndex === activeIndex) {
          trigger.classList.add('active');
        } else {
          trigger.classList.remove('active');
        }
      });
    }
  }

  // Initialize hotspots when DOM is ready
  function initializeHotspots() {
    const hotspotsContainers = document.querySelectorAll('[data-hotspots-container]');

    hotspotsContainers.forEach((container) => {
      const triggers = container.querySelectorAll('[data-hotspot-trigger]');
      const cards = container.querySelectorAll('[data-product-card]');

      if (triggers.length > 0 && cards.length > 0) {
        new HotspotsManager(container);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initializeHotspots);

  // Re-initialize for theme editor
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-hotspots-container]');
    if (container) {
      const triggers = container.querySelectorAll('[data-hotspot-trigger]');
      const cards = container.querySelectorAll('[data-product-card]');
      console.log('Section reload - triggers:', triggers.length, 'Cards:', cards.length);

      if (triggers.length > 0 && cards.length > 0) {
        new HotspotsManager(container);
      }
    }
  });

  // Also try initializing after a short delay in case blocks load asynchronously
  setTimeout(initializeHotspots, 100);
  } catch(e) { console.error(e); }
})();

})();
